
import React, { useEffect } from "react";
import CustomButton from "../CustomButton";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";

export default function CustomHeader() {
  const router = useNavigate()
  const [cookies, setCookie, removeCookie] = useCookies(['TokenAdmin']);

  useEffect(() => {
    if(cookies.TokenAdmin == undefined){
      router('/admin',{replace:true})
    }
  }, [])
  
  return (
    <div className="bg-[#1D2327] py-3 px-8 flex flex-row items-center">
      <img src="/img/white logo.png" className="w-[180px] object-contain" />
      <CustomButton
        onClick={()=>{router('/admin/post/add')}}
        txt={"New Post"}
        bgcolor="#2271B1"
        classAdditional=" font-semibold ml-10 hidden sm:flex"
      />
      <CustomButton
        onClick={()=>{router('/admin/products/add')}}
        txt={"New Product"}
        bgcolor="#2271B1"
        classAdditional=" font-semibold ml-3 hidden sm:flex "
      />
      <div className="flex-[1]">

      </div>
      <div className="font_Barlow font-medium text-[32px] mr-5 text-white">
        Admin
      </div>
      <div className="p-2 bg-white rounded-lg">
        <img src="/img/admin.png" className="w-[22px] object-contain" />
      </div>
    </div>
  );
}
